import React from "react";

const EmailIcon = ({ fill = "#555555", ...delegated }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...delegated}
    >
      <path
        d="M0 8.60767L10 12.3577L20 8.60767V16.1077C20 16.7978 19.7526 17.3902 19.2578 17.885C18.776 18.3668 18.1901 18.6077 17.5 18.6077H2.5C1.8099 18.6077 1.21745 18.3668 0.722656 17.885C0.240885 17.3902 0 16.7978 0 16.1077V8.60767ZM2.5 3.60767H17.5C18.1901 3.60767 18.776 3.85506 19.2578 4.34985C19.7526 4.83162 20 5.41756 20 6.10767V6.73267L10 10.4827L0 6.73267V6.10767C0 5.41756 0.240885 4.83162 0.722656 4.34985C1.21745 3.85506 1.8099 3.60767 2.5 3.60767Z"
        fill={fill}
      />
    </svg>
  );
};

export { EmailIcon };
